import { useState, useEffect, useLayoutEffect, useRef, useMemo } from 'react';
import { getRoundedRectPerimeter } from '../utils/roundedRectPerimeter';

const BORDER_REVEAL_DELAY_MS = 50;
export function useAnimatedBorder() {
  const containerRef = useRef(null);
  const [borderDims, setBorderDims] = useState(null);
  const [borderVisible, setBorderVisible] = useState(false);

  useLayoutEffect(() => {
    if (!containerRef.current) return;
    const measure = () => {
      const { width, height } = containerRef.current.getBoundingClientRect();
      if (width && height) setBorderDims({ width, height });
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(containerRef.current);
    return () => ro.disconnect();
  }, []);

  useEffect(() => {
    if (!borderDims) return;
    const t = setTimeout(() => setBorderVisible(true), BORDER_REVEAL_DELAY_MS);
    return () => clearTimeout(t);
  }, [borderDims]);

  const borderPerimeter = useMemo(
    () => (borderDims ? getRoundedRectPerimeter(borderDims) : 0),
    [borderDims]
  );

  return { containerRef, borderDims, borderPerimeter, borderVisible };
}
